'use client';

import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '../utils/cn';

/**
 * Internal shadcn primitive. Do not import directly from app code.
 * Use /ui UzInput instead.
 */
export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'border-input bg-background flex h-10 w-full rounded-md border px-3 py-2 text-sm transition-colors',
        'file:text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium',
        // Lighter than the default `text-muted-foreground` (~zinc-500) so
        // placeholders read as "hint text" rather than "already filled" -
        // the in-form distinction operators wanted on the lead form.
        'placeholder:text-muted-foreground/50',
        // Focus highlights the field's own border (no offset ring sitting outside it).
        'focus-visible:border-ring focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
